module.exports = __webpack_public_path__ + "static/media/chat.522c7d30.svg";